import { UserInterfaceClient } from '@@api';

type ReactCodeDownloadClient = Pick<UserInterfaceClient, 'downloadReactCode'>;

export async function downloadAppReactCode(
	client: ReactCodeDownloadClient,
	definitionId: string,
	changeSetId: string | undefined,
	fallbackFileName: string,
): Promise<void> {
	const archive = await client.downloadReactCode(definitionId, changeSetId);
	const downloadUrl = URL.createObjectURL(archive.data);
	const downloadLink = document.createElement('a');
	downloadLink.href = downloadUrl;
	downloadLink.download = archive.fileName || fallbackFileName;
	document.body.appendChild(downloadLink);
	downloadLink.click();
	downloadLink.remove();
	URL.revokeObjectURL(downloadUrl);
}
